import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Actions } from '@src/app/shared/backend/auth/Action';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';
import { UnregisteredUsersService, RetailersService } from '@src/app/shared/backend/clients';
import { ConfirmationService } from 'primeng/api';
import { DialogReasonComponent } from '@src/app/shared/components/dialog-reason/dialog-reason.component';

@Component({
    selector: 'app-view-unregistered-user',
    templateUrl: './view-unregistered-user.component.html',
    styleUrl: './view-unregistered-user.component.scss',
    host: {
        class: 'app-view-unregistered-user'
    },
    providers: [ConfirmationService],
    standalone: false
})
export class ViewUnregisteredUserComponent extends BaseViewComponent implements OnInit {

  @ViewChild('dialog') dialog: DialogReasonComponent | undefined;

  allowModifyUnregisteredUser: boolean = false;

  unregisteredUserId: number | null = null;
  retailersAssignedTo: any[] = [];
  unregisteredUser: any = {
    id: null
  };

  allowModifyUser: boolean = false;
  delete: boolean = false;

  canViewRetailers: boolean = false;

  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private unregisteredUsersService: UnregisteredUsersService,
    private retailersService: RetailersService,
    private confirmationService: ConfirmationService,
  ) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params.subscribe(async params => {
      this.unregisteredUserId = Number(params['unregisteredUserId']);
      if (this.unregisteredUserId) {
        await this.get();
      }
    });
  }

  override async get() {
    await this.getChild(this.unregisteredUserId);
  }

  override async getChild(id: any) {

    try {
      this.unregisteredUserId = Number(id);

      this.unregisteredUser = await firstValueFrom(
        this.unregisteredUsersService.apiUnregisteredUsersDetailsIdGet(this.unregisteredUserId)
      );

      const retailerIdsResponse = await firstValueFrom(
        this.unregisteredUsersService.apiUnregisteredUsersIdRetailerIdsGet(this.unregisteredUserId)
      );

      const retailerIds: number[] = Array.isArray(retailerIdsResponse?.retailerIds)
        ? retailerIdsResponse.retailerIds.filter((retailerId: any) => retailerId != null)
        : [];

      this.retailersAssignedTo = await Promise.all(
        retailerIds.map(async (retailerId: number) => {
          try {
            return await firstValueFrom(this.retailersService.apiRetailersIdGet(retailerId));
          } catch {
            return null;
          }
        })
      );

      this.retailersAssignedTo = this.retailersAssignedTo.filter(Boolean);

      this.allowModifyUnregisteredUser = await this.permissionService.hasActionPermissions(Actions.modify_users);
      this.canViewRetailers = await this.permissionService.hasActionPermissions(Actions.view_retailers);
      this.delete = await this.permissionService.hasActionPermissions(Actions.delete);

    } catch (error) {
      console.log('Error fetching unregistered user data:', error);
    } finally {
      this.changeDetector.detectChanges();
    }
  }

  goToEditUnregisteredUser() {
    this.router.navigate([`/unregistered-users/${this.unregisteredUserId}/edit`]);
  }

  async deleteUnregisteredUser(doDelete: boolean): Promise<void> {
    if (doDelete) {
      const unregisteredUserId = Number(this.unregisteredUserId);
      await firstValueFrom(this.unregisteredUsersService.apiUnregisteredUsersDeleteIdDelete(unregisteredUserId));

      this.router.navigate([`/unregistered-users`]);
    }
  }
}
